import script from "./ResourceBookingsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResourceBookingsView.vue?vue&type=script&setup=true&lang=ts"

import "./ResourceBookingsView.vue?vue&type=style&index=0&id=37c10348&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37c10348"]])

export default __exports__